import styled from "styled-components";

import Heading from "@vfuk/core-heading";
import Icon from "@vfuk/core-icon";
import Paragraph from "@vfuk/core-paragraph";
import Spacing from "@vfuk/core-spacing";

const ContainerStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export type EmptyViewProps = {
  iconName: string;
  iconGroupName: string;
  title: string;
  description?: string | React.ReactNode;
};

export const EmptyView = ({
  iconName,
  iconGroupName,
  title,
  description,
}: EmptyViewProps) => {
  return (
    <Spacing
      spacingLevel={{
        bottom: 12,
        top: 12,
      }}
    >
      <ContainerStyles>
        <Spacing
          spacingLevel={{
            bottom: 4,
          }}
        >
          <Icon name={iconName} group={iconGroupName} size={4} />
        </Spacing>

        <Heading level={3} justify="center" weight={3} size={2}>
          {title}
        </Heading>
        {description && <Paragraph>{description}</Paragraph>}
      </ContainerStyles>
    </Spacing>
  );
};
